import CHEVRON_ARROW from "@assets/actions/Chevron_left_grey.svg";
import { QNCardType } from "@typings/QuickNews";
import { memo, ReactElement } from "react";

type QNCardNavProps = {
  activeTab: QNCardType;
  canPrevFeed: boolean;
  canPrevVideo: boolean;
  canNextFeed: boolean;
  canNextVideo: boolean;
  onPrev: () => void;
  onNext: () => void;
};

type NavButtonProps = {
  ariaLabel: string;
  onClick: () => void;
  disabled: boolean;
  rotation: "UP" | "DOWN";
};

const NavButton = memo(
  ({
    ariaLabel,
    onClick,
    disabled,
    rotation,
  }: NavButtonProps): ReactElement => (
    <button
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center justify-center w-12 h-12 rounded-full disabled:opacity-30 disabled:cursor-not-allowed opacity-80 hover:opacity-100 transition-opacity duration-300 group"
    >
      <img
        height="44px"
        width="44px"
        className={`block p-1 transition-transform duration-300 group-hover:scale-105 ${rotation === "UP" ? "rotate-90" : "-rotate-90"}`}
        alt="Navigation"
        src={CHEVRON_ARROW}
      />
    </button>
  ),
);

NavButton.displayName = "NavButton";

export default function QnCardNav({
  activeTab,
  canPrevFeed,
  canPrevVideo,
  canNextFeed,
  canNextVideo,
  onPrev,
  onNext,
}: QNCardNavProps): ReactElement {
  const isPrevDisabled = activeTab === "MyFeed" ? !canPrevFeed : !canPrevVideo;
  const isNextDisabled = activeTab === "MyFeed" ? !canNextFeed : !canNextVideo;

  return (
    <div className="hidden md:flex fixed z-30 top-1/2 -translate-y-1/2 left-[calc(50%+250px)] flex-col gap-6">
      <NavButton
        ariaLabel="Previous card"
        onClick={onPrev}
        disabled={isPrevDisabled}
        rotation="UP"
      />
      <NavButton
        ariaLabel="Next card"
        onClick={onNext}
        disabled={isNextDisabled}
        rotation={"DOWN"}
      />
    </div>
  );
}
